export default () => ({
  entity: 'policy',
  entities: 'policies',
  currentEntity: {},
  policies: [],
  errors: {
  }
})



// WEBPACK FOOTER //
// ./src/app/professional/privacy-policy/index/resources/data.js